<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<Table :data="tableData2" :columns="tableColumns2" size="large" :loading="loading" header="header" footer="footer">
			<template slot-scope="{ row, index }" slot="state">
				<Tag color="success">正常</Tag>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<router-link tag="a" :to="{path:'modify/'+row.id}">
					<Button type="warning">
						修改
					</Button>
				</router-link>
			</template>

			<template slot="header">
				<div class="flex justify-between">
					<div span="12" class="padding-left">
					</div>
					<div span="12">
						<div style="text-align: right;">
							<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
							 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
						</div>
					</div>
				</div>

			</template>
			<template slot="footer">
				<div style="text-align: right;">
					<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
					 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
				</div>
			</template>
		</Table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				tableColumns2: [{
						title: '序号',
						type: 'index',
						align: 'center',
						width: 68
					},
					{
						title: 'ID',
						align: 'center',
						key: 'id'
					},
					{
						title: '会员',
						align: 'center',
						key: 'name'
					},
					{
						title: '状态',
						slot: 'state',
						align: 'center'
					},
					{
						title: '券码',
						key: 'viewtimes',
						align: 'center'
					},
					{
						title: '领取时间',
						key: 'addtime',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						width: 220

					}
				],
				tableData2: [],
				searchForm: {
					page: 1,
					size: 20,
					total: 0,
					kname: ''
				}
			};
		},
		methods: {
			loadinfos() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/client/activity/coupon/log/list.php?a=list', this.searchForm).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.searchForm.total = res.data.data.total;
							this.tableData2 = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			pageChange(page) {
				this.searchForm.page = page;
				this.loadinfos();
			},
			pageSizeChange(size) {
				this.searchForm.size = size;
				this.loadinfos();
			}
		},
		created() {
			this.loadinfos();
		}
	};
</script>

<style>
	.demo-spin-icon-load {
		font-size: 5em;
		animation: ani-demo-spin 1s linear infinite;
	}
</style>
